import React from 'react'
import Bullet from '@/components/StrapiComponents/Bullet'

const Taglist = ({ component, className }) => {
  const { bullets } = component
  return (
    <div className={`py-2 ${className}`}>
      {bullets.map((component, index) => (
        <Bullet key={index} component={component} />
      ))}
    </div>
  )
}

export default Taglist
